var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app overflow-hidden darkColor"},[(_vm.pageLoaded)?_c('particles',{staticClass:"hidden-md-and-down"}):_vm._e(),_c('nav-bar'),_c('router-view',{attrs:{"workshops":_vm.workshops}}),_c('footer-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }